import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { getGivingHistory } from '@sola/proxy-sdk/utils/routes.ts';
import { QUERY_KEYS } from '../constants.ts';
import { useReadyForQueries } from './base.ts';

/**
 * Hook to fetch giving history.
 *
 * TODO Mocks
 */
export const useGivingHistory = year => {
  const $ = _c(8);
  const {
    isReady,
    globalId
  } = useReadyForQueries();
  let t0;
  if ($[0] !== year) {
    t0 = [QUERY_KEYS.supporterGivingHistory, year];
    $[0] = year;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== globalId) {
    t1 = t2 => {
      const {
        queryKey
      } = t2;
      const [, queryYear] = queryKey;
      return getGivingHistory(globalId, {
        start: `${queryYear}-01-01`,
        end: `${queryYear}-12-31`
      });
    };
    $[2] = globalId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== isReady || $[5] !== t0 || $[6] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      refetchOnWindowFocus: false,
      enabled: isReady,
      staleTime: Infinity
    };
    $[4] = isReady;
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useQuery(t2);
};